import { Modal, Alert } from 'antd'
import { ExclamationCircleFilled, InfoCircleFilled } from '@ant-design/icons'
import IconClose from 'components/Icons/Close'
import Button from 'components/UI/Buttom'
import Check from 'components/Icons/Check'
import { type Recommendation } from 'types/services/Recommedation'
import { type CSSProperties } from 'react'

import './styles.scss'
import { Loading } from 'components/UI'
import { useAccessibility } from 'context/hooks/useAccessibility'

import iconChecked from 'assets/icons/check-preenchido.svg'

interface ModalSendRecommendationProps {
  question: string
  answer: string
  justification: string
  modalIsOpen: boolean
  isAlert: boolean
  infosRecommedation: Recommendation
  isRecommendationSend: boolean
  loading: boolean
  closeModal: () => void
  action: (id: number) => void
}

function ModalSendRecommendation({
  question,
  answer,
  justification,
  modalIsOpen,
  closeModal,
  action,
  isAlert,
  infosRecommedation,
  isRecommendationSend,
  loading,
}: ModalSendRecommendationProps) {
  const alert = isAlert ? 'alert' : ''
  const styleSituationIcon: CSSProperties = isAlert
    ? { fontSize: '32px', color: '#F67D7D' }
    : { fontSize: '32px', color: '#80C470' }

  const { contrastIsSelected } = useAccessibility()

  if (loading) {
    return (
      <Modal
        className={`containerModalSend ${
          contrastIsSelected ? 'contrastMode' : ''
        }`}
        visible={modalIsOpen}
        bodyStyle={{
          backgroundColor: contrastIsSelected
            ? 'var(--contrast-background-color)'
            : 'var(--background)',
          ...(contrastIsSelected && {
            color: contrastIsSelected
              ? 'var(--contrast-foreground-color)'
              : '#2D4040',
            border: '1px solid var(--contrast-foreground-color)',
          }),
          borderRadius: '10px',
          padding: '0',
        }}
        closable={false}
        maskStyle={
          !contrastIsSelected
            ? { backgroundColor: 'rgba(45, 64, 64, 0.62)' }
            : { backgroundColor: 'var(--contrast-background-color)' }
        }
      >
        <Loading
          styles={{ padding: '30% 0' }}
          title="Encaminhando a recomendação..."
        />
      </Modal>
    )
  }

  return (
    <Modal
      className={`containerModalSend ${
        contrastIsSelected ? 'contrastMode' : ''
      }`}
      visible={modalIsOpen}
      onCancel={closeModal}
      closable={true}
      bodyStyle={{
        backgroundColor: contrastIsSelected
          ? 'var(--contrast-background-color)'
          : 'var(--background)',
        ...(contrastIsSelected && {
          color: contrastIsSelected
            ? 'var(--contrast-foreground-color)'
            : '#2D4040',
        }),
        boxShadow: 'var(--default-shadow)',
        borderRadius: '10px',
        padding: '0',
      }}
      closeIcon={<IconClose size="14px" />}
      maskStyle={
        !contrastIsSelected
          ? { backgroundColor: 'rgba(45, 64, 64, 0.62)' }
          : { backgroundColor: 'var(--contrast-background-color)' }
      }
    >
      <div className="containerModalSend__main">
        <div className="containerModalSend__main-title">
          <h3>Deseja mesmo encaminhar?</h3>
        </div>

        {isRecommendationSend && (
          <div className="containerModalSend__main-alertIsSend">
            <Alert
              description={
                'Uma recomendação já foi encaminhada anteriormente para esse alerta.'
              }
              type="info"
              icon={<InfoCircleFilled />}
              showIcon
            />
          </div>
        )}
        <div className={`containerModalSend__main-situation ${alert}`}>
          <div className="containerModalSend__main-situation__header">
            <div>
              <strong>{question}</strong>
              <span>{answer}</span>
            </div>
            {isAlert ? (
              <ExclamationCircleFilled style={styleSituationIcon} />
            ) : (
              <img src={iconChecked} alt="ok" height="32px" />
            )}
          </div>
          {isAlert && (
            <Alert
              description={justification}
              type="info"
              icon={<InfoCircleFilled />}
              showIcon
            />
          )}
        </div>
        <div className="containerModalSend__main-recommendation">
          <strong>Recomendação</strong>
          <span>{infosRecommedation.recommendationText}</span>
        </div>

        <div className="containerModalSend__main-aditionalInfos">
          <strong>
            Agente: {infosRecommedation?.responsibleAgent ?? `Não informado`}
          </strong>
          <strong>
            {' '}
            Instituição: {infosRecommedation?.institutionRecommender}
          </strong>
          <span>Telefone: {infosRecommedation?.phoneRecommender}</span>
          <span>E-mail: {infosRecommedation?.emailRecommender}</span>

          <hr style={{ marginTop: '1rem' }} />
          <strong> Autor: {infosRecommedation?.createdBy}</strong>
          <span>
            {' '}
            Instituição: {infosRecommedation?.institutionRecommender}
          </span>
          <span>
            Criado em:{' '}
            {infosRecommedation.createdAt !== null &&
              new Date(infosRecommedation.createdAt).toLocaleDateString()}
          </span>
        </div>

        <div className="containerModalSend__main-buttons">
          <Button
            title="Sim, encaminhar"
            disabled={false}
            type="primary"
            icon={<Check />}
            onClick={() => {
              action(infosRecommedation.id ?? 0)
            }}
          />
          <Button
            title="Não, cancelar"
            icon={<IconClose size="13px" />}
            onClick={() => {
              closeModal()
            }}
          />
        </div>
      </div>
    </Modal>
  )
}

export default ModalSendRecommendation
